import React, { Component } from 'react'
import PropTypes from 'prop-types'
import fetchApi from '../../services/fetchApi'
import { renderAlert } from '../../services/render-alert'
import css from './message-report-subscripton.css'

class MessageReportSubscription extends Component {
  static propTypes = {
    locationId: PropTypes.string,
    locationName: PropTypes.string,
  }
  constructor(props) {
    super(props)

    this.state = {
      isSaveDisabled: true,
      isEditing: true,
      emails: '',
    }
  }

  componentDidMount() {
    this.getSubscription()
  }

  getSubscription = () => {
    fetchApi(this.urlForFetch, 'GET').then((res) => {
      const emails = res.emails || ''
      this.setState({
        emails,
        isEditing: !emails,
      })
    })
  }

  updateSubscription = (ev) => {
    ev.preventDefault()

    const value = this.state.emails
    const body = JSON.stringify({ emails: value })

    fetchApi(this.urlForFetch, 'PUT', { body })
      .then((res) => {
        const { emails } = res || ''
        this.setState({
          isSaveDisabled: true,
          hasError: false,
          emails,
          isEditing: !emails,
        })

        const msg = value ? 'Successfully updated subscription' : 'Unsubscribed'

        renderAlert(msg, 'success')
      })
      .catch((error) => {
        this.setState({ hasError: true })
        const msg = error.body.error
        renderAlert(msg)
      })
  }

  urlForFetch = this.props.locationId
    ? `/message_report_subscription?location_id=${this.props.locationId}`
    : '/message_report_subscription'

  handleEmail = (ev) => {
    const newValue = ev.target.value
    this.setState({ emails: newValue })
  }

  _handleEditing = (nextState) => {
    this.setState({ isEditing: nextState })
  }

  editingOn = (ev) => {
    ev.preventDefault()
    this._handleEditing(true)
  }
  editingOff = (ev) => {
    ev.preventDefault()
    this._handleEditing(false)
  }

  render() {
    const { locationName } = this.props
    const { emails, isEditing } = this.state
    let buttonHandler
    let buttonText
    let emailField

    if (!isEditing) {
      buttonHandler = this.editingOn
      buttonText = 'Edit'
      emailField = <span className={css.email}>{emails}</span>
    } else {
      buttonHandler = this.updateSubscription
      buttonText = 'Save'
      emailField = (
        <input
          className={css.email}
          type="email"
          placeholder="first@example.com, second@example.com"
          onChange={this.handleEmail}
          value={emails}
          disabled={!isEditing}
        />
      )
    }

    const updateTitle = locationName ? (
      <h3>Update message report subscription for {locationName}</h3>
    ) : (
      <h3>Update message report subscription for the practice</h3>
    )

    return (
      <div className={css.wrapper}>
        <form onSubmit={this.attemptSave}>
          <h3>{updateTitle}</h3>
          {emailField}
          <button className={css.button} onClick={buttonHandler} type="submit">
            {buttonText}
          </button>
          <p className={css.help}>
            To subscribe, type in emails separated by commas. To unsubscribe, clear emails.
          </p>
        </form>
      </div>
    )
  }
}

export default MessageReportSubscription



// WEBPACK FOOTER //
// ./src/components/Account/MessageReportSubscription.js